// Ajaxing SVG sprite

import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class AddSvgIconSprite extends WebComponent {
  didMount() {
    let xhr = new XMLHttpRequest();
    const container = this.element;
    const path = container.getAttribute('data-url');

    if ('withCredentials' in xhr) {
      xhr.withCredentials;
      xhr.open('GET', path, true);
    } else if (typeof XDomainRequest != 'undefined') {
      xhr = new XDomainRequest();
      xhr.open('GET', path);
    } else {
      document.body.className += ' no-svg-sprite';
    }

    xhr.onload = function () {
      container.innerHTML = xhr.responseText;
    };

    xhr.onerror = function () {
      document.body.className += ' no-svg-sprite';
    };

    setTimeout(function () {
      xhr.send();
    }, 0);

  }
}



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/components/AddSvgIconSprite.js